/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_FailedInputs */

const en_push_failed = /** @type {(inputs: Push_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications could not be changed on this device`)
};

/**
* | output |
* | --- |
* | "Notifications could not be changed on this device" |
*
* @param {Push_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const push_failed = /** @type {((inputs?: Push_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_push_failed(inputs)
});